import { get, post, put } from "./api_helper"

// branches
const getListPage = params => get("admin/fabric-inventory/page", params)
const getDetailPage = params =>
  get(`admin/fabric-inventory/${params.id}/detail/page`, {
    page: params.page,
    size: params.size,
  })
const getDetail = id => get(`admin/fabric-inventory/${id}`)
const putData = params => put(`admin/fabric-inventory/${params.id}`, params)

const FabricInventoryAPI = {
  getListPage,
  getDetailPage,
  getDetail,
  putData,
}

export default FabricInventoryAPI
